import React from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { useCases } from "./useCaseData";
import RequestDemo from "../RequestDemo";

const UseCaseAccordion = () => {
  return (
    <Container className="mt-5" fluid style={{ background: "#e8f3ff" }}>
      <Container className="p-md-5">
        <Row>
          <Col md="3" className="d-flex justify-content-center align-items-center">
            <h5 className="text-lg px-2">
              <span className="text-blue">GAINSS in Action –</span>{" "}
              <span className="text-light-blue">
                Solving Real-World Challenges
              </span>
            </h5>
            {/* <p>Built for Every Challenge in Software Testing</p> */}

            <Container fluid className="px-0">
              {/* <Row>
                <Col>
                  <h5>Ready to Transform Your Testing?</h5>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p>
                    No matter your challenge, GAINSS empowers teams to optimize
                    testing, accelerate delivery, and achieve higher quality
                    standards.
                  </p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <RequestDemo />
                </Col>
              </Row> */}
              {/* <Row className="mt-4">
                <Col>
                  <a
                    href="https://www.gtentechnologies.com/documentation/about/?type=tool"
                    variant="outline-primary"
                    target="_blank"
                    rel="noreferrer"
                    className="btn-rounded get-started btn btn-outline-primary"
                  >
                    Learn How GAINSS Can Help Your Team
                  </a>
                </Col>
              </Row> */}
            </Container>
          </Col>
          <Col className="mt-4 mt-md-0 mb-4 mb-md-0">
            <Accordion defaultActiveKey={0}>
              {useCases.map((useCase, index) => (
                <Accordion.Item key={index} eventKey={index} className="mt-3">
                  <Accordion.Header>
                    <span className="text-grey">{useCase.title}</span>
                  </Accordion.Header>
                  <Accordion.Body className="px-4">
                    <p className="text-606060">
                      <strong>Challenge:</strong> {useCase.challenge}
                    </p>
                    <p className="text-606060">
                      <strong>Solution:</strong> {useCase.solution}
                    </p>
                    <p className="text-606060">
                      <strong>Outcome:</strong> {useCase.outcome}
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default UseCaseAccordion;
